import { render, staticRenderFns } from "./FlexSpacer.vue?vue&type=template&id=765131a2&scoped=true&"
import script from "./FlexSpacer.vue?vue&type=script&lang=js&"
export * from "./FlexSpacer.vue?vue&type=script&lang=js&"
import style0 from "./FlexSpacer.vue?vue&type=style&index=0&id=765131a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765131a2",
  null
  
)

export default component.exports